
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { User, UserProgress } from '@/types/user';

interface AccountTabProps {
  user: User;
  userProgress: UserProgress;
}

const AccountTab: React.FC<AccountTabProps> = ({ user, userProgress }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Account Settings</CardTitle>
        <CardDescription>
          Manage your account preferences and personal information
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <div>
            <h3 className="text-sm font-medium mb-2">Personal Information</h3>
            <div className="grid gap-3">
              <div className="flex justify-between p-3 bg-muted rounded-md">
                <span className="text-muted-foreground">Name</span>
                <span className="font-medium">{user.name}</span>
              </div>
              <div className="flex justify-between p-3 bg-muted rounded-md">
                <span className="text-muted-foreground">Email</span>
                <span className="font-medium">{user.email}</span>
              </div>
              <div className="flex justify-between p-3 bg-muted rounded-md">
                <span className="text-muted-foreground">Member since</span>
                <span className="font-medium">June 2023</span>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="text-sm font-medium mb-2">Program Progress</h3>
            <div className="grid gap-3">
              <div className="flex justify-between p-3 bg-muted rounded-md">
                <span className="text-muted-foreground">Current day</span>
                <span className="font-medium">Day {userProgress.currentDay}</span>
              </div>
              <div className="flex justify-between p-3 bg-muted rounded-md">
                <span className="text-muted-foreground">Streak</span>
                <span className="font-medium">{userProgress.streak} days</span>
              </div>
              <div className="flex justify-between p-3 bg-muted rounded-md">
                <span className="text-muted-foreground">Completed days</span>
                <span className="font-medium">{userProgress.completedDays.length}</span>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AccountTab;
